var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-12"},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Anmerkungen")]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"name":"remarks"}})])])])])}]
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38e1b9c7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/templates/semperit/assets/js/modules/checkout/components/extra-fields/components/ExtraFields.vue
// module id = nnqE
// module chunks = 4